/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AISparkleIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="AISparkleIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2 8.5V7.5C5.03757 7.5 7.5 5.03757 7.5 2H8.5C8.5 5.03757 10.9624 7.5 14 7.5V8.5C10.9624 8.5 8.5 10.9624 8.5 14H7.5C7.5 10.9624 5.03757 8.5 2 8.5ZM8 11.4956C8.65852 9.91976 9.91976 8.65852 11.4956 8C9.91976 7.34148 8.65852 6.08024 8 4.5044C7.34148 6.08024 6.08024 7.34148 4.5044 8C6.08024 8.65852 7.34148 9.91976 8 11.4956Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

AISparkleIcon.tags = [
  'AI',
  'sparkle',
  'star',
  'diamond',
  'shine',
  'glow',
  'twinkle',
  'radiance',
];

AISparkleIcon.category = 'General Icons';

AISparkleIcon.iconSize = 16;
